"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var CommentController_1 = __importDefault(require("Project/Comments/CommentController"));
var Comment = function (props) {
    var id = props.id, commentThreadStore = props.commentThreadStore, user = props.user, usersInAccount = props.usersInAccount, showMarker = props.showMarker, editorElem = props.editorElem, children = props.children, permissionsStore = props.permissionsStore, projectId = props.projectId, pendingUsersDataStore = props.pendingUsersDataStore, inviteNewUser = props.inviteNewUser;
    var commentStore = commentThreadStore.commentThreadsById[id];
    var showComment = commentStore && !commentStore.isDeleted;
    var onMouseEnter = function () {
        if (commentStore) {
            commentStore.setActive(true);
        }
    };
    var onMouseLeave = function () {
        if (commentStore) {
            commentStore.setActive(false);
        }
    };
    return showComment ? (react_1.default.createElement("span", { className: (0, classnames_1.default)({
            comment: true,
            "comment--is-active": commentStore.isActive,
            "comment--is-hidden": commentStore.isResolved,
        }), "data-slate-leaf": "true" },
        react_1.default.createElement("span", { className: "comment-inner" },
            children,
            showMarker && (react_1.default.createElement("span", { className: "comment-inner-marker", onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, contentEditable: false },
                react_1.default.createElement(CommentController_1.default, { commentGroupStore: commentStore, user: user, usersInAccount: usersInAccount, containerElem: editorElem, projectId: projectId, permissionsStore: permissionsStore, pendingUsersDataStore: pendingUsersDataStore, inviteNewUser: inviteNewUser })))))) : (children);
};
exports.default = (0, mobx_react_1.observer)(Comment);
